<div class="row">
  <div class="col">
    <h5>{{sectionTitle}}</h5>
  </div>
  <div class="col-auto">
    <button type="button" class="btn btn-light" (click)="goBack()">
      Back
    </button>
  </div>
</div>

<ng-container *ngIf="isReady">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="mb-5">
    <div class="row">
      <div class="col-12">
        <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
        <ng-content></ng-content>
      </div>
    </div>
    <div class="mt-3 text-end">
      <button [disabled]="isSubmitting" type="button" class="btn btn-light" (click)="onCancel()">Cancel</button>
      <button [disabled]="isSubmitting" type="submit" class="btn btn-primary ms-3">
        <span><i class="fas fa-spinner fa-spin" *ngIf="isSubmitting"></i> {{buttonTitle}}</span>
      </button>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="!isReady">
  <app-spinner></app-spinner>
</ng-container>

